import styled from "styled-components";

export const Background = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100dvh;
	background: rgba(0, 0, 0, 0.8);
	z-index: 999;
	display: ${(props) => (props.isOpen ? 'flex' : 'none')};
	justify-content: center;
	align-items: center;
	padding: 20px;
	box-sizing: border-box;
	overflow: hidden;
`;

export const OrderFormContainer = styled.div`
	width: 100%;
	max-width: 400px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 4px 10px rgba(20, 20, 20, 0.5);
	z-index: 1000;
	max-height: 97%;
	overflow-y: scroll;
`;


export const PopupHeader = styled.div`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;

	span {
		margin: 0;
        font-size: 20px;
        font-weight: bold;
	}

	button {
        position: absolute;
        right: 10px;
		background: none;
		border: none;
		font-size: 16px;
		cursor: pointer;
	}
    button:hover {
        color: red;
    }
`;

export const PopupBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;

    div {
        margin-left: 10px;
        display: flex;
        
        span {
            margin-left: 5px;
        }
    }
`;

export const SectionExtras = styled.div`
    display: flex;
    flex-direction: column;

    div {
		margin-left: 10px;
        display: flex;

		label {
			display: flex;
			width: 100%;
			border-bottom: 1px solid #ccc;
			justify-content: space-between;
		}
        
        span {
            margin-left: 10px;
        }
    }
`;

export const Select = styled.div`
	select {
		width: 100%;
		padding: 10px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

    option {
        color: #2c3135;
    }
`;

export const PopupFooter = styled.div`
	display: flex;
	justify-content: center;

	button {
		padding: 2.5px 20px;
        margin: 10px;
		background: #FEC108;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
	}

	button:hover {
		background: #FEC10890;
	}
`;

export const Observations = styled.div`
	display: flex;
	flex-direction: column;

	textarea {
		margin-left: 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		text-indent: 10px;
		color: #333;
	}

	textarea:focus {
		border: 1px solid #007bff;
		color: #007bff;
	}
`;